import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {RouterService} from '../RouterService';

declare var initScript: any;

@Component({
    selector: 'app-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {

    title = 'Products - Hitec';

    constructor(private titleService: Title, public routerService: RouterService) {
        titleService.setTitle(this.title);
    }

    ngOnInit(): void {
    }

    redirect(url): void {
        this.routerService.redirect(url);
    }

}
